<script setup lang="ts">
import AccountImpersonateListItem from '@/components/AccountImpersonateListItem.vue'
import AccountLogoutListItem from '@/components/AccountLogoutListItem.vue'
import AccountProfileListItem from '@/components/AccountProfileListItem.vue'
import { useAccountMenu } from '@/composables/useAccountMenu'
import { APP_BAR_ICON_COLOR } from '@/constants/practiceConstants'
import store from '@/store'

defineProps<{
  tabs: { label: string; path: string }[]
}>()

const { doStopImpersonate } = useAccountMenu()
</script>

<template>
  <v-menu location="bottom end">
    <template #activator="{ props }">
      <v-btn
        v-bind="props"
        class="mr-2"
        :color="store.getters.user.impersonator ? 'warning' : undefined"
        icon
        size="small"
        :style="store.getters.user.impersonator ? {} : { color: APP_BAR_ICON_COLOR }"
      >
        <v-icon>mdi-menu</v-icon>
      </v-btn>
    </template>

    <v-list>
      <v-list-item v-if="store.getters.user.impersonator" class="text-warning" @click="doStopImpersonate">
        <v-list-item-title>Impersonating {{ store.getters.user.user?.firstName }}</v-list-item-title>
        <v-list-item-subtitle>Tap to stop</v-list-item-subtitle>
        <template #append>
          <v-icon color="error">mdi-incognito</v-icon>
        </template>
      </v-list-item>

      <v-divider v-if="store.getters.user.impersonator" />

      <v-list-item v-for="tab in tabs" :key="tab.path" :to="tab.path">
        <v-list-item-title>{{ tab.label }}</v-list-item-title>
      </v-list-item>

      <v-divider />

      <account-profile-list-item />

      <account-impersonate-list-item />

      <account-logout-list-item />
    </v-list>
  </v-menu>
</template>
